const TOTAL_ROW_ID = "total_id";

const toolHasVulnerabilitiesData = (toolData) => {
  return Boolean(
    toolData?.vulnerabilities_medium >= 0 ||
      toolData?.vulnerabilities_high >= 0 ||
      toolData?.vulnerabilities_critical >= 0 ||
      toolData?.associations_medium >= 0 ||
      toolData?.associations_high >= 0 ||
      toolData?.associations_critical >= 0
  );
};

export const getRows = (
  dataByTimestamp,
  selectedTimestampIndex,
  orderedTimestamps
) => {
  if (!dataByTimestamp) return [null, null];
  const selectedTimestamp = orderedTimestamps[selectedTimestampIndex];
  const selectedData = dataByTimestamp[selectedTimestamp];

  const previousScanTimestamp =
    selectedTimestampIndex < orderedTimestamps.length - 1
      ? orderedTimestamps[selectedTimestampIndex + 1]
      : null;

  const rows = [];

  for (const [toolName, toolData] of Object.entries(
    selectedData.data_per_tool
  )) {
    if (!toolHasVulnerabilitiesData(toolData)) continue;

    const toolTotalVulnerabilities = getRowTotalVulnerabilities(toolData);
    const toolTotalAssociations = getRowTotalAssociations(toolData);

    const toolRow = {
      source: toolName,
      vulnerabilities_medium: toolData?.vulnerabilities_medium,
      associations_medium: toolData?.associations_medium,
      vulnerabilities_high: toolData?.vulnerabilities_high,
      associations_high: toolData?.associations_high,
      vulnerabilities_critical: toolData?.vulnerabilities_critical,
      associations_critical: toolData?.associations_critical,
      vulnerabilities_total: toolTotalVulnerabilities,
      associations_total: toolTotalAssociations,
    };

    let previousScanToolData = null;
    if (previousScanTimestamp)
      previousScanToolData =
        dataByTimestamp[previousScanTimestamp].data_per_tool[toolName];
    if (previousScanToolData) {
      const previousScanToolTotalVulnerabilities =
        getRowTotalVulnerabilities(previousScanToolData);
      const previousScanToolTotalAssociations =
        getRowTotalAssociations(previousScanToolData);

      toolRow.vulnerabilitiesMediumDiff =
        previousScanToolData.vulnerabilities_medium != null
          ? toolData.vulnerabilities_medium -
            previousScanToolData.vulnerabilities_medium
          : null;
      toolRow.vulnerabilitiesHighDiff =
        previousScanToolData.vulnerabilities_high != null
          ? toolData.vulnerabilities_high -
            previousScanToolData.vulnerabilities_high
          : null;
      toolRow.vulnerabilitiesCriticalDiff =
        previousScanToolData.vulnerabilities_critical != null
          ? toolData.vulnerabilities_critical -
            previousScanToolData.vulnerabilities_critical
          : null;
      toolRow.associationsMediumDiff =
        previousScanToolData.associations_medium != null
          ? toolData.associations_medium -
            previousScanToolData.associations_medium
          : null;
      toolRow.associationsHighDiff =
        previousScanToolData.associations_high != null
          ? toolData.associations_high - previousScanToolData.associations_high
          : null;
      toolRow.associationsCriticalDiff =
        previousScanToolData.associations_critical != null
          ? toolData.associations_critical -
            previousScanToolData.associations_critical
          : null;
      toolRow.vulnerabilitiesTotalDiff =
        previousScanToolTotalVulnerabilities != null
          ? toolTotalVulnerabilities - previousScanToolTotalVulnerabilities
          : null;
      toolRow.associationsTotalDiff =
        previousScanToolTotalAssociations != null
          ? toolTotalAssociations - previousScanToolTotalAssociations
          : null;
    }
    rows.push(toolRow);
  }

  const totalRow = buildTotalRow(rows);
  rows.push(totalRow);

  const pinnedRows = {
    bottom: [totalRow],
  };
  return [rows, pinnedRows];
};

const getRowTotalVulnerabilities = (toolData) => {
  if (
    toolData?.vulnerabilities_medium == null ||
    toolData?.vulnerabilities_high == null ||
    toolData?.vulnerabilities_critical == null
  )
    return null;

  return (
    (toolData?.vulnerabilities_medium || 0) +
    (toolData?.vulnerabilities_high || 0) +
    (toolData?.vulnerabilities_critical || 0)
  );
};

const getRowTotalAssociations = (toolData) => {
  if (
    toolData?.associations_medium == null ||
    toolData?.associations_high == null ||
    toolData?.associations_critical == null
  )
    return null;

  return (
    (toolData?.associations_medium || 0) +
    (toolData?.associations_high || 0) +
    (toolData?.associations_critical || 0)
  );
};

const getColumnTotal = (rows, columnName) => {
  if (rows.every((row) => row[columnName] == null)) return null;
  return rows.reduce((acc, row) => acc + row[columnName], 0);
};

const buildTotalRow = (rows) => {
  const totalRow = {
    source: TOTAL_ROW_ID,
    vulnerabilities_medium: getColumnTotal(rows, "vulnerabilities_medium"),
    vulnerabilitiesMediumDiff: getColumnTotal(
      rows,
      "vulnerabilitiesMediumDiff"
    ),
    vulnerabilities_high: getColumnTotal(rows, "vulnerabilities_high"),
    vulnerabilitiesHighDiff: getColumnTotal(rows, "vulnerabilitiesHighDiff"),
    vulnerabilities_critical: getColumnTotal(rows, "vulnerabilities_critical"),
    vulnerabilitiesCriticalDiff: getColumnTotal(
      rows,
      "vulnerabilitiesCriticalDiff"
    ),
    associations_medium: getColumnTotal(rows, "associations_medium"),
    associationsMediumDiff: getColumnTotal(rows, "associationsMediumDiff"),
    associations_high: getColumnTotal(rows, "associations_high"),
    associationsHighDiff: getColumnTotal(rows, "associationsHighDiff"),
    associations_critical: getColumnTotal(rows, "associations_critical"),
    associationsCriticalDiff: getColumnTotal(rows, "associationsCriticalDiff"),
    vulnerabilities_total: getColumnTotal(rows, "vulnerabilities_total"),
    vulnerabilitiesTotalDiff: getColumnTotal(rows, "vulnerabilitiesTotalDiff"),
    associations_total: getColumnTotal(rows, "associations_total"),
    associationsTotalDiff: getColumnTotal(rows, "associationsTotalDiff"),
  };

  return totalRow;
};
